import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {createArticle, fetchArticle, resetArticle, updateArticle} from "../../../creators/article";

import {Button, ButtonGroup} from "../Button";
import {CheckboxInputField, DateInputField, RadioInputField, SearchTextInputField, TextInputField} from "../FormField";
import moment from "moment-timezone";
import Modal from "../Modal";
import MkEditor from "../editor/Editor";
import {fetchUserFriends} from "../../../creators/user.friends";
import Uploader from "../upload/SingleUpload";
import DraftContentReader from "../editor/DraftContentReader";
import {PageLoader} from "../Loader";
import Avatar from "../Avatar";
import Icon from "../Icon";
import TagList from "../TagList";
import AutocompletedTag from "../AutocompletedTag";

class AdvancedEditorArticle extends React.Component {
    constructor(props){
        super(props);

        let datePublisher = moment(this.props.article.publishedAt ? this.props.article.publishedAt : "").format("YYYY-MM-DD HH:mm");
        let publishDate = moment().diff(datePublisher, 'minutes') <= 0;

        this.filter = {
            page: 1,
            limit: 20,
            search: "",
        };
        this.editorRef = React.createRef();
        this.initialArticle = {
            title: "",
            tags: [],
            // content: "",
            contentRaw: {},
            comment: {
              allowed: true,
              toValidate: false
            },
            cover: "",
            coverId : null,
            right: "guest",
            members: [],
            status: true,
            publishedAt: ""
        };

        this.state = {
            article: this.initialArticle,
            filter: this.filter,
            addTag: '',
            publishDate,
            datePublisher: datePublisher,
            showPreview: false,
            titleError: false,
            contentError: false,
            openUpload: false,
            // coverUploadData: "",
            // preview: "",
            // fileCover: {}
        };

        this.handleValue = this.handleValue.bind(this);
        this.handleCommentModeration = this.handleCommentModeration.bind(this);
        // this.handleAddTag = this.handleAddTag.bind(this);
        this.removeTags = this.removeTags.bind(this);
        this.getUserFriends = this.getUserFriends.bind(this);
        this.handleAddFriend = this.handleAddFriend.bind(this);
        this.handleDeleteFriend = this.handleDeleteFriend.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        // this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handlePublishDate = this.handlePublishDate.bind(this);
        this.getUploadData = this.getUploadData.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAddTags = this.handleAddTags.bind(this);
        this.handleSubmitMessageTimeout = this.handleSubmitMessageTimeout.bind(this);

        if(this.props.articleId){
            this.props.fetchArticle(this.props.articleId, {nocache : true});
        }
        // else {
        //     this.props.createArticle();
        // }
        this.getUserFriends(this.state.filter);
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.article !== this.props.article && this.props.articleId){
            this.setState({article: {
                    ...this.state.article,
                    title: this.props.article.title,
                    tags: this.props.article.tags,
                    excerpt: this.props.article.excerpt,
                    // content: this.props.article.content,
                    contentRaw: this.props.article.contentRaw,
                    status: this.props.article.status,
                    right: this.props.article.right,
                    cover: this.props.article.cover,
                    coverId : this.props.article.coverId,
                    members: this.props.article.members,
                    comment: {
                        allowed: this.props.article.comment.allowed,
                        toValidate: this.props.article.comment.toValidate
                    },
                    publishedAt: this.props.article.publishedAt,
            }});
        }
    }

    componentWillUnmount() {
        if(!this.props.articleId){
            this.props.resetArticle();
        }
    }

    getUserFriends(filter){
        let query = {...filter};
        this.props.fetchUserFriends(this.props.currentUser && this.props.currentUser._id && this.props.currentUser._id, query);
    }

    handleValue(name, value){
        if(this.state.article.title.length === 0 && (this.state.article.contentRaw && this.state.article.contentRaw.blocks && this.state.article.contentRaw.blocks.length === 0)){
            this.setState({error: true, article : {...this.state.article, [name] : value}});
        } else {
            let members = this.state.article.members;
            if(value === "private" || value === "guest"  || value === "friends"){
                members = [];
            }
            this.setState({article : {...this.state.article, [name] : value, members}});
        }
    }

    handleCommentModeration(name, value){
        this.setState({article : {...this.state.article, comment: {...this.state.article.comment, [name] : value}}});
    }

    // handleAddTag(event) {
    //     this.setState({addTag: event.target.value})
    // }

    removeTags(currentIndex) {
        let tags = this.state.article.tags;
        tags.splice(currentIndex, 1);
        this.setState({article: {...this.state.article, tags}});
        if (typeof (this.props.handleTags) !== "undefined") {
            this.props.handleTags(tags);
        }
    }

    // handleKeyPress(event) {
    //     if (event.key === "Enter" && this.state.addTag.length >= 1 && this.state.article.tags.length <= 9) {
    //         let tags = [...this.state.article.tags, {title: this.state.addTag}];
    //         this.setState({addTag: "", article : {...this.state.article, tags}});
    //         if (typeof (this.props.handleTags) !== "undefined") {
    //             this.props.handleTags(tags);
    //         }
    //     }
    // }

    handleAddTags(tag) {
        // if (event.key === "Enter" && this.state.addTag.length >= 1 && this.state.article.tags.length <= 9) {
            let tags = this.state.article.tags;
            tags.push(tag);
            this.setState({article : {...this.state.article, tags}});
            if (typeof (this.props.handleTags) !== "undefined") {
                this.props.handleTags(tags);
            }
        // }
    }

    handlePublishDate() {
        this.setState({article: {...this.state.article, publishedAt : moment().format("YYYY-MM-DD HH:mm")}, datePublisher: moment().format("YYYY-MM-DD HH:mm") ,publishDate: !this.state.publishDate});
    }

    getUploadData(data, preview){
        let article = {...this.state.article, cover: data.preview, coverId : data._id};
        this.setState({article});
    }

    handleDeleteCoverImg(){
        if(!this.props.article.cover){
            let article = {...this.state.article, cover: "", coverId : null};
            this.setState({article });
        } else {
            let article = {...this.state.article, cover: "", coverId : null};
            // console.log("supprimer l'image de cover");
            this.setState({article});
        }
    }

    handleSearch(value){
        this.setState({filter: {...this.state.filter, search: value}});
        this.getUserFriends({...this.state.filter, search: value});
    }

    handleAddFriend(friend){
        let friendAlreadyAdded = this.state.article.members.filter(item => item._id.toString() === friend._id.toString());
        if(friendAlreadyAdded.length === 0){
            this.state.article.members.push({_id: friend._id, profile: friend.profile, username: friend.username});
        } else return null;
        this.setState({filter: {...this.state.filter, search: ""}});
    }

    handleDeleteFriend(_id) {
        let members = this.state.article.members;
        let newMembers = members.filter(item => item._id.toString() !== _id.toString());
        this.setState({article: {...this.state.article, members: newMembers}});
    }

    handleSubmit(){
        setTimeout(()=>{
            this.handleSubmitMessageTimeout();
        },50)
    }

    handleSubmitMessageTimeout(){
        let hasText = this.editorRef.current.handleHasText();
        if(this.state.article.title.length >= 1 && hasText){
            //TODO: mettre les friends en Id uniquement dans le tableau
            // let files = {};
            let contentRaw = this.state.article.contentRaw;
            // if(this.state.filesCover && this.state.filesCover.cover){
            //     files = { ...this.state.filesCover};
            // }

            if(this.state.article.contentRaw.entityMap){
                // files = {
                //     ...files,
                //     "contentRaw.entityMap" : Object.values(this.state.article.contentRaw.entityMap)
                // };
                // let contentFiles = Object.values(this.state.article.contentRaw.entityMap);
                // contentFiles.forEach((item,index) =>{
                //     if(item.type === "UPLOADED_MEDIA"){
                //         let key = `contentRaw.entityMap[${index}].data.uri`;
                //         files = {
                //             ...files,
                //             [key] : item.data.id
                //         }
                //         if(contentRaw.entityMap[index].data && contentRaw.entityMap[index].data.id){
                //             delete contentRaw.entityMap[index].data.id;
                //         }
                //     }
                //
                // });

            }


            if(this.props.articleId){
                this.props.updateArticle(this.props.articleId, {...this.state.article, contentRaw});
            } else {
                if(this.state.publishDate){
                    this.props.createArticle({...this.state.article, contentRaw, publishedAt : moment(this.state.article.publishedAt).utc()});
                } else {
                    this.props.createArticle({...this.state.article, contentRaw, publishedAt: null});
                }
            }
            this.props.handleClose();
        }

        if (!hasText) {
            this.setState({contentError: true});
        } else {
            this.setState({contentError: false});
        }

        if (this.state.article.title.length === 0) {
            this.setState({titleError: true});
        } else {
            this.setState({titleError: false});
        }
    }


    render(){

        return (this.props.articleId && this.props.articleLoading) ? (
            <div className={"advanced-editor modal-container"}>
                <PageLoader/>
            </div>
        ) : (
            <div className={"advanced-editor modal-container"}>
                <div className={"modal-topline"}>
                    <div>{this.props.articleId ? `Edition de l'article : ${this.state.article.title}` : "Création d'un article"}</div>
                </div>
                <div className={"modal-body"}>
                    <div className={"main"}>
                        <div className={"inner-block"}>
                            <span className={"input-label"}>Titre</span>
                            <TextInputField value={this.state.article.title}
                                            placeholder={"Titre de votre sujet"}
                                            error={this.state.titleError}
                                            onChange={(event)=>this.handleValue("title", event.target.value)} />
                        </div>

                        <div className={"inner-block"}>
                            <span className={"input-label"}>Étiquettes du sujet</span>

                            <div className="row align-flex-end full add-tag-container">
                                {this.state.article.tags.length < 10 && (<AutocompletedTag addTag={this.handleAddTags} />)}
                                <TagList className="classic" tags={this.state.article.tags}
                                         removeTags={this.removeTags}/>
                            </div>
                            <span className="max-tag">Sélectionner au maximum 10 étiquettes ({this.state.article.tags.length} / 10)</span>
                        </div>

                        <div className="inner-block img-cover-preview">
                            <label>Image de couverture du billet</label>
                            {(this.state.article.cover === "") && (
                                <Button btnStyle={"primary-reverse"}
                                        size={"small"}
                                        onClick={()=>this.setState({openUpload: true})}
                                        content={"Ajouter une photo de couverture"}/>
                            )}
                                <Modal toggle={this.state.openUpload} handleClose={()=>this.setState({openUpload: false})}>
                                    <Uploader getUploadData={this.getUploadData}
                                              uploadPath={"/articles/upload-cover"}
                                              kind={"article"}
                                              handleClose={()=>this.setState({openUpload: false})} />
                                </Modal>
                            {this.props.articleId && this.state.article.cover !== "" ? (
                                <Fragment>
                                    <div className={"img-preview-container"}>
                                        <img className={"img-preview"} alt="" src={`${this.state.article.cover}`} />
                                    </div>
                                    <Button btnStyle={"cancel-reverse"}
                                            size={"small"}
                                            onClick={()=>this.handleDeleteCoverImg()}
                                            content={"Supprimer l'image"}/>
                                </Fragment>
                            ) : (
                                (this.state.article.cover) && (
                                    <Fragment>
                                        <div className={"img-preview-container"}>
                                            <img className={"img-preview"} alt="" src={this.state.article.cover} />
                                        </div>
                                        <Button btnStyle={"cancel-reverse"}
                                            size={"small"}
                                            onClick={()=>this.handleDeleteCoverImg()}
                                            content={"Supprimer l'image"}/>
                                    </Fragment>
                                )
                            )}

                        </div>

                        <div className={"inner-block"}>
                            <span className={"input-label"}>Contenu de la publication</span>
                            {this.props.articleId && this.state.article.contentRaw && this.state.article.contentRaw.blocks && (
                                <MkEditor onChange={(contentRaw) => this.setState({article: {...this.state.article, contentRaw}})}
                                          ref={this.editorRef}
                                          className={this.state.contentError ? "error" : ""}
                                          kind={"articles"}
                                          userFriends={this.props.userFriends}
                                          defaultValue={this.state.article.contentRaw}/>
                            )}
                            {this.props.articleId && this.props.articleLoading && (
                                <PageLoader />
                            )}
                            {!this.props.articleId && (
                                <MkEditor onChange={(contentRaw) => this.setState({article: {...this.state.article, contentRaw}})}
                                          ref={this.editorRef}
                                          kind={"articles"}
                                          className={this.state.contentError ? "error" : ""}
                                          userFriends={this.props.userFriends}/>
                            )}
                        </div>
                    </div>
                    <div className="sidebar">
                        <div className="advanced-editor-block">
                            <h4>Publication</h4>
                            {(!this.props.articleId || this.state.publishDate) && (
                                <div className="advanced-editor-content">
                                    <ButtonGroup>
                                        <Button size={"small"}
                                                onClick={() => this.handlePublishDate()}
                                                active={this.state.publishDate}
                                                content={"Publier en différé"}/>
                                        <Button size={"small"}
                                                active={!this.state.publishDate}
                                                onClick={() => this.handlePublishDate()}
                                                content={"Publier immédiatement"}/>
                                    </ButtonGroup>
                                    {this.state.publishDate && (
                                        <div className="column">
                                            <DateInputField value={this.state.article.publishedAt}
                                                            format={"DD/MM/YYYY HH:mm"}
                                                            showTime={true}
                                                            nameOfValueToUpdate={"publishedAt"}
                                                            convertToFormat={"YYYY-MM-DD HH:mm"}
                                                            handleValue={this.handleValue}/>
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className="advanced-editor-content">
                                <CheckboxInputField checked={!this.state.article.status}
                                                    label={"Enregistrer en tant que brouillon"}
                                                    id={"saveAsDraft"}
                                                    htmlFor={"saveAsDraft"}
                                                    onChange={() => this.handleValue("status", !this.state.article.status)} />
                            </div>
                        </div>
                        <div className="advanced-editor-block">
                            <h4>Commentaire</h4>
                            <div className="advanced-editor-content">
                                <CheckboxInputField checked={this.state.article.comment.allowed}
                                                    label={"Autoriser les commentaires"}
                                                    id={"allowComments"}
                                                    htmlFor={"allowComments"}
                                                    onChange={() => this.handleCommentModeration("allowed", !this.state.article.comment.allowed)} />

                                <CheckboxInputField checked={this.state.article.comment.toValidate}
                                                    label={"Modérer les commentaires"}
                                                    id={"validateComments"}
                                                    htmlFor={"validateComments"}
                                                    onChange={() => this.handleCommentModeration("toValidate", !this.state.article.comment.toValidate)} />
                            </div>
                        </div>
                        <div className="advanced-editor-block">
                            <h4>Affichage</h4>
                            <div className="advanced-editor-content">
                                <RadioInputField checked={this.state.article.right === "guest"}
                                                 label={"Public"}
                                                 id={"rightGuest"}
                                                 name={"right"}
                                                 htmlFor={"rightGuest"}
                                                 onChange={() => this.handleValue("right", "guest")} />

                                <RadioInputField checked={this.state.article.right === "private"}
                                                 label={"Privé"}
                                                 name={"right"}
                                                 id={"rightPrivate"}
                                                 htmlFor={"rightPrivate"}
                                                 onChange={() => this.handleValue("right", "private")} />
                                <RadioInputField checked={this.state.article.right === "friends"}
                                                 label={"Amis"}
                                                 name={"right"}
                                                 id={"rightFriends"}
                                                 htmlFor={"rightFriends"}
                                                 onChange={() => this.handleValue("right", "friends")} />

                                <RadioInputField checked={this.state.article.right === "privateclub"}
                                                 label={"Club Privé"}
                                                 name={"right"}
                                                 id={"privateClub"}
                                                 htmlFor={"privateClub"}
                                                 onChange={() => this.handleValue("right", "privateclub")} />

                                {this.state.article.right === "privateclub" && (
                                    <SearchTextInputField value={this.state.filter.search}
                                                          loading={this.props.userFriendsLoading}
                                                          total={this.props.userFriendsTotal}
                                                          placeholder={"Rechercher un(e) ami(e)"}
                                                          list={this.props.userFriends}
                                                          getItem={this.handleAddFriend}
                                                          handleSearch={this.handleSearch} />
                                )}
                                {this.state.article.members.length >= 1 && (
                                    <div className={"private-club-container"}>
                                        {this.state.article.members.map((item => (
                                            <div key={item._id} className="friends-container">
                                                <div className="friend">
                                                    <Avatar gender={item.profile.gender} avatar={item.profile.avatar}
                                                            className="user-thumb" alt=""/> {item.username}
                                                </div>
                                                <span onClick={() => this.handleDeleteFriend(item._id)}><Icon
                                                    type="close"/></span>
                                            </div>
                                        )))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"modal-baseline"}>
                    {(this.state.titleError || this.state.contentError) && (
                        <span className={"red"}>Vous n'avez pas complété tous les champs</span>
                    )}
                    <Button btnStyle={"grey"}
                            size={"small"}
                            onClick={()=>this.props.handleClose()}
                            content={"Annuler"}/>
                    <Button btnStyle={"primary-reverse"}
                            size={"small"}
                            onClick={()=>this.setState({showPreview: true})}
                            content={"Prévisualiser"}/>
                    <Button btnStyle={"primary-reverse"}
                            onClick={()=>this.handleSubmit()}
                            size={"small"}
                            loading={this.props.articleSubmitting}
                            content={this.props.articleId ? 'Editer' : 'Publier'}/>
                </div>
                <Modal toggle={this.state.showPreview} handleClose={()=>this.setState({showPreview: false})}>
                    <div className={"modal-container article-preview container"}>
                        <div className={"modal-topline"}>
                            Prévisualisation de l'article
                        </div>
                        <div className={"modal-body"}>
                            <div className="wrapper-text-article full">
                                <DraftContentReader contentRaw={this.state.article.contentRaw} />
                            </div>
                        </div>
                        <div className={"modal-baseline"}>
                            <Button onClick={()=>this.setState({showPreview: false})}
                                    btnStyle={"primary-reverse"}
                                    size={"small"}
                                    content={"Quitter"}/>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        article: state.article.data,
        articleLoading: state.article.loading,
        articleInitialized: state.article.initialized,
        articleSubmitting: state.article.submitting,

        currentUser: state.currentUser.data,

        userFriends: state.userFriends.data,
        userFriendsLoading:state.userFriends.loading,
        userFriendsTotal:state.userFriends.total,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchArticle,
    resetArticle,
    createArticle,
    updateArticle,

    fetchUserFriends,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(AdvancedEditorArticle);